import React from 'react';

export type AlertContextType = {
    showAlert: (type: string, value?: string, duration?: number) => void;
};

export const AlertContext = React.createContext({} as AlertContextType);
